<!--
 * @Author: marshall
 * @Date: 2022-07-12 14:43:24
 * @LastEditTime: 2025-03-31 00:52:31
 * @LastEditors: marshall 18670505746@163.com
 * @Description: 
 * @FilePath: /jh-h5-utils/src/components/PrivacyPolicy.vue
 * 广州鲸鸿网络科技有限公司版权所有 ©
-->

<template>
    <h5-dialog
        showCloseButton
        title="个人信息收集清单"
        @close="$emit('close', false)"
        v-show="visible"
    >
        <van-cell-group
            title="可能收集以下信息："
            style="margin-bottom:20px;"
            v-if="info.length > 0"
        >
            <van-cell v-for="item in info" :key="item.key">
                <template #title>{{ item.keyName }}</template>
                <template #default>
                    <span style="color:#999;">{{ item.collect == 1 ? '已收集' : '未收集' }}</span>
                </template>
                <template #right-icon>
                    <van-icon
                        :name="item.collect == 1 ? 'checked' : 'clear'"
                        :color="item.collect == 1 ? '#58be6a' : '#da3231'"
                        size="20px"
                        style="margin-left:4px;"
                    />
                </template>
            </van-cell>
        </van-cell-group>
        <van-empty v-else description="暂未收集" />
    </h5-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { CellGroup, Cell, Icon, Empty } from 'vant'
import H5Dialog from './H5Dialog.vue'
import { getPrivacyPolicy } from '../service/index.js'

const userEnum = {
    is_idcard: { label: '身份证号码' },
    is_ip: { label: 'IP地址' },
    is_mobile: { label: '手机号码' },
    is_muid: { label: '唯一设备标识' },
    is_password: { label: '密码' },
    is_position: { label: '位置' },
    is_real_name: { label: '真实姓名' },
    is_region: { label: '地区' },
    is_transaction: { label: '交易信息' },
    is_username: { label: '用户名' },
}

// let userTimeout = null

export default {
    data() {
        return {
            info: [],
        }
    },
    model: {
        prop: 'visible',
        event: 'close'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        H5Dialog,
        VanCell: Cell,
        VanCellGroup: CellGroup,
        VanIcon: Icon,
        VanEmpty: Empty,
    },
    computed: {
        ...mapState({
            username: state => state?.app?.appConfig?.username || ''
        })
    },
    methods: {
        queryPrivacyInfo() {
            getPrivacyPolicy({ username: this.username }).then(res => {
                if (res?.code == 0) {
                    const userInfo = res?.data || {}
                    this.info = Object.entries(userInfo).map(([key, value]) => {
                        return {
                            key: key,
                            keyName: userEnum[key]?.label || '--',
                            collect: value
                        }
                    })
                }
            })
        },
    },
    mounted() {
        // userTimeout = setTimeout(() => {
        //     this.queryPrivacyInfo()
        // }, 200)
    },
    beforeDestroy() {
        // clearTimeout(userTimeout)
    }
}
</script>

<style lang="scss" scoped>

</style>